import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle, XCircle, Loader2 } from "lucide-react";

export default function PaymentResult({ ok }) {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [state, setState] = useState(ok ? "checking" : "cancel");
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (!ok || !sessionId) return;
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setState("paid"); return; }
        if (data.status === "expired" || tries > 6) { setState("timeout"); return; }
      } catch { /* ignore */ }
      tries++; setTimeout(poll, 1800);
    };
    poll();
  }, [ok, sessionId]);

  const Box = ({ icon, title, sub, color }) => (
    <div className="min-h-screen flex items-center justify-center bg-slate-100 p-4">
      <div className="bg-white rounded-2xl shadow-xl border border-slate-100 p-8 text-center max-w-sm">
        <div className={color}>{icon}</div>
        <h2 className="font-display text-xl font-bold text-slate-900 mt-3">{title}</h2>
        <p className="text-slate-500 mt-1">{sub}</p>
        <button onClick={() => nav("/agenda")} className="mt-5 px-4 py-2 rounded-lg bg-[#141821] text-white text-sm font-medium">Retour à l'application</button>
      </div>
    </div>
  );

  if (state === "checking") return <Box icon={<Loader2 className="w-14 h-14 mx-auto animate-spin" />} color="text-emerald-500" title="Vérification du paiement…" sub="Merci de patienter quelques secondes." />;
  if (state === "paid") return <Box icon={<CheckCircle className="w-14 h-14 mx-auto" />} color="text-emerald-500" title="Paiement confirmé" sub="Le paiement a bien été enregistré." />;
  if (state === "timeout") return <Box icon={<Loader2 className="w-14 h-14 mx-auto" />} color="text-yellow-500" title="Paiement en cours" sub="Le statut sera mis à jour automatiquement." />;
  return <Box icon={<XCircle className="w-14 h-14 mx-auto" />} color="text-red-500" title="Paiement annulé" sub="Aucun montant n'a été débité." />;
}
